import React from "react";
import { TouchableOpacity, View } from "react-native";
import { Text, Timer } from "components";

import { colors, strings } from "assets/constants";
import { mq } from "utils";
import css from "styles";

interface TimerSectionT {
  getCodeAgain: () => void;
}

export default function TimerSection(props: TimerSectionT) {
  const isCurrent = React.useRef(true);
  const [showTimer, setShowTimer] = React.useState(true);

  const finishTimer = () => isCurrent && setShowTimer(false);

  React.useEffect(() => {
    return () => {
      isCurrent.current = false;
    };
  }, []);
  return (
    <View style={[{ height: mq(25), margin: mq(30) }, css.selfCenter]}>
      {showTimer ? (
        <View style={css.rowCenterAlign}>
          <Text>{strings.until_code_resent("")} </Text>

          <View style={{ borderRadius: 5, marginHorizontal: 4 }}>
            <Timer hideHour onFinish={finishTimer} duration={180} />
          </View>
        </View>
      ) : (
        <TouchableOpacity
          style={{ width: mq(250) }}
          onPress={() => {
            props.getCodeAgain();
            setShowTimer(true);
          }}
        >
          <View style={[css.rowCenterAlign, css.selfCenter]}>
            <Text style={css.textUnderline} color={colors.info}>
              {" "}
              {strings.send_code_again}{" "}
            </Text>
            <Text>{strings.did_not_receive_code}</Text>
          </View>
        </TouchableOpacity>
      )}
    </View>
  );
}
